import { render, staticRenderFns } from "./AnnouncementPopup.vue?vue&type=template&id=1376968e&scoped=true&"
import script from "./AnnouncementPopup.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPopup.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementPopup.vue?vue&type=style&index=0&id=1376968e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376968e",
  null
  
)

export default component.exports